const COLLISION_CODES = new Set(['identity_already_exists', 'email_exists', 'user_already_exists']);

export interface AuthRedirect {
  collision: boolean;
  errorCode: string | null;
}

/** Reads the OAuth error Supabase appends to the redirect. Leaves the PKCE code alone. */
export function parseAuthRedirect(href: string): AuthRedirect {
  const url = new URL(href, 'http://localhost');
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
  const errorCode =
    url.searchParams.get('error_code') ||
    hash.get('error_code') ||
    url.searchParams.get('error') ||
    hash.get('error');
  const description = `${url.searchParams.get('error_description') ?? ''} ${hash.get('error_description') ?? ''}`.toLowerCase();
  const collision =
    (errorCode !== null && COLLISION_CODES.has(errorCode)) ||
    (description.includes('already') && (description.includes('identity') || description.includes('linked') || description.includes('exists')));
  return { collision, errorCode };
}

/** Drops OAuth error params after they have been shown. Keeps a PKCE code for the client. */
export function stripAuthErrorParams(href: string): string {
  const url = new URL(href, 'http://localhost');
  for (const key of ['error', 'error_code', 'error_description']) {
    url.searchParams.delete(key);
  }
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
  for (const key of ['error', 'error_code', 'error_description']) hash.delete(key);
  const hashText = hash.toString();
  url.hash = hashText ? `#${hashText}` : '';
  return `${url.pathname}${url.search}${url.hash}`;
}
